import $ from 'jquery';

var $rest = {};
var keyRegex = /^(\S+?)(?=\(\S+\)|$)(?:\((\S+)\))?$/;

// determine if in TeamSite preview
function isTeamSitePreview() {
  if (window.location.href.indexOf('teamsite.tms.aws.toyota.com') > -1) {
    return true;
  }
  return false;
}

/* eslint-disable no-else-return */
function __processUrlParams(url, params) {
  // Build the request path
  // This replaces elements in the url according to the format
  // {data param:default value}
  url = url.replace(/\{\{|\}\}|\{([^}: ]+?)(?::([^}]*?))?\}/g, function (match, name, def) {
    if (match === '{{') {
      return '{';
    } else if (match === '}}') {
      return '}';
    } else {
      var raw = false;
      if (name.indexOf('!') >= 0) {
        var tokens = name.split('!');
        var mod = tokens[0];
        raw = mod === 'raw';
        name = tokens[1];
      }
      if (params[name] !== void 0) {
        var v = params[name];
        delete params[name];
        return raw ? v : encodeURIComponent(v);
      } else {
        return def === void 0 ? '' : def;
      }
    }
  });

  // if TeamSite module preview, use the correct BATWS URL
  // could be considered hacky since the ajaxPrefilter is not working (for this)
  if (isTeamSitePreview() && (url && url === '/BATWS/cls/getSeries.json')) {
    url = url.replace('/BATWS/', '/iw-mount/default/main/Toyota/BAT/ADMIN/WORKAREA/shared_wa/web_docs/BATWS/');
  }
  return url;
}

function __generateApi(target, key, config) {
  var match = keyRegex.exec(key);
  var path = match[1];
  var argName = match.length === 3 ? match[2] : null;

  var api = function () {
    var result = Object.create(api.prototype);
    if (argName) {
      var context = {};
      context[argName] = arguments.length >= 1 ? arguments[0] : '';
      result.context = $.extend({}, this.context, context);
    }

    return result;
  };

  // TODO: Add deep api support
  var proto = {
    _rest: target,
    context: null,
    url: config.url
  };

  $.each(config.calls, function (name, config) {
    proto[name] = __generateRequest(name, config, proto);
  });

  api.prototype = proto;
  target[path] = api;
  return api;
}

function __generateRequest(name, config, api) {
  var request = function () {
    var url = api.url + (config.url === void 0 ? name : config.url);
    var params = $.extend({}, config.defaults, this.context);

    url = url.replace(/\/+/g, '/'); // remove any double //

    if (api._rest.spec.host) {
      url = api._rest.spec.host + url;
    }

    if (arguments.length) {
      $.extend(params, arguments[0]);
    }
    var requestConfig = $.extend({}, { method: 'GET' }, config, { url: url });
    return api._rest.makeRequest(requestConfig, params);
  };

  return request;
}

function RestAPI(spec, options) {
  this.spec = spec;
  this.defaults = $.extend({}, options);

  var self = this;
  $.each(spec.apis, function (key, reqConfig) {
    __generateApi(self, key, reqConfig);
  });
}

RestAPI.prototype.makeRequest = function (config, params) {
  params = $.extend({}, this.defaults.params, params);

  var url = __processUrlParams(config.url, params);

  if (config.stringify) {
    params = JSON.stringify(params);
  }

  if (config.generator === true) {
    if (config.immediate === true) {
      return url;
    } else {
      return Promise.resolve({ url: url });
    }
  } else {
    var reqConfig = {
      method: config.method,
      url: url,
      data: params
    };

    $.each(['accepts', 'dataType', 'contentType', 'processData'], function (idx, k) {
      if (config.hasOwnProperty(k)) {
        reqConfig[k] = config[k];
      }
    });

    return $.ajax(reqConfig);
  }
};

export default RestAPI;
